import { Label as RadixLabel, Separator as RadixSeparator, Content as RadixContent, SubContent as RadixSubContent, Item as RadixItem, SubTrigger as RadixSubTrigger } from '@radix-ui/react-dropdown-menu';
import styled, { css } from 'styled-components';
import { DISABLED_STATE_ATTRIBUTE, SELECTED_STATE_ATTRIBUTE, tokens } from './tokens';
import { Size } from './types';
export const itemStyles = css`
  all: unset;
  outline: none;
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-family: ${tokens.Item.fontFamily};
  font-size: ${tokens.Item.fontSize};
  font-weight: ${tokens.Item.fontWeight};
  line-height: ${tokens.Item.lineHeight};
  letter-spacing: ${tokens.Item.letterSpacing};
  color: ${tokens.Item.color};
  cursor: pointer;
  padding: ${({ size = Size.md })=>tokens.size[size].padding};
  border-radius: ${tokens.Item.borderRadius};
  &:focus,
  &:hover {
    background: ${tokens.Item.state.hovered.background};
  }

  &[${SELECTED_STATE_ATTRIBUTE}='true'] {
    background: ${tokens.Item.state.selected.background};
  }

  ${({ dragging, draggingStarted })=>dragging || draggingStarted ? `
      ${dragging ? `
        background: ${tokens.Item.state.dragging.background};
        border: 1px solid ${tokens.Item.state.dragging.borderColor};
        box-shadow: ${tokens.Item.state.dragging.boxShadow};
      ` : `
        border: 1px dashed ${tokens.Item.state.draggingStarted.borderColor};
        color: ${tokens.Item.state.draggingStarted.color};
      `}
  ` : ''}

  &[${DISABLED_STATE_ATTRIBUTE}] {
    cursor: not-allowed;
    color: ${tokens.Item.state.disabled.color};
    box-shadow: none;
    &:focus,
    &:hover {
      background: unset;
    }
  }
`;
export const contentStyles = css`
  display: flex;
  flex-direction: column;

  min-width: 220px;
  padding: ${({ size = Size.md })=>tokens.size[size].padding};
  background: ${tokens.Content.background};
  box-shadow: ${tokens.Content.shadow};
  border-radius: ${tokens.Content.borderRadius};
  border: 1px solid ${tokens.Content.borderColor};
  z-index: ${tokens.Content.zIndex};
`;
export const Content = styled(RadixContent)`
  ${contentStyles}
`;
export const SubContent = styled(RadixSubContent)`
  ${contentStyles}
`;
export const labelStyles = css`
  font-family: ${tokens.Label.fontFamily};
  font-size: ${tokens.Label.fontSize};
  font-weight: ${tokens.Label.fontWeight};
  line-height: ${tokens.Label.lineHeight};
  letter-spacing: ${tokens.Label.letterSpacing};

  padding: ${tokens.Label.padding};
  color: ${tokens.Label.color};
`;
export const Label = styled(RadixLabel)`
  ${labelStyles}
`;
export const Separator = styled(RadixSeparator)`
  border-top: ${tokens.Separator.border};
  border-radius: ${tokens.Separator.borderRadius};
  margin: ${tokens.Separator.margin} 0;
`;
export const Item = styled(RadixItem)`
  ${itemStyles}
`;
export const SubTrigger = styled(RadixSubTrigger)`
  ${itemStyles}
`;
